
































import { Component, Mixins, Vue } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import GJgrowEventCreateBaseSettingDateSpan from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateBaseSettingDateSpan.vue';
import GJgrowEventCreateTerm from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTerm.vue';
import GJgrowEventCreateTermEventDate from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTermEventDate.vue';
import GJgrowEventCreateTermExamAtBefore from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTermExamAtBefore.vue';
import GJgrowEventCreateTermExamAtAfter from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTermExamAtAfter.vue';
import GJgrowEventCreateTermSurveyAtBefore from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTermSurveyAtBefore.vue';
import GJgrowEventCreateTermSurveyAtAfter from '@/views/GJgrowEventCreate/BaseSetting/GJgrowEventCreateTermSurveyAtAfter.vue';
import { GEnum } from '@/constants/enum.defination';
import { masterModule } from '@/store/modules/entities/master.module';
import { EventParam } from '@/models/jgrow/event-param';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { required } from 'vuelidate/lib/validators';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';

@Component({
  name: 'GJgrowEventCreateBaseSetting',
  components: {
    GVTag,
    GJgrowEventCreateBaseSettingDateSpan,
    GJgrowEventCreateFormFormat,
    GJgrowEventCreateTerm,
    GJgrowEventCreateTermEventDate,
    GJgrowEventCreateTermExamAtBefore,
    GJgrowEventCreateTermExamAtAfter,
    GJgrowEventCreateTermSurveyAtBefore,
    GJgrowEventCreateTermSurveyAtAfter,
  },
  computed: {},
  methods: {},
  validations: {
    eventParam: {
      title: { required },
      destination: { required },
    },
  },
})
export default class GJgrowEventCreateBaseSetting extends Mixins(GPageBase) {
  mounted() {}

  // テスト用データ
  get destinations(): any {
    return masterModule.destinations;
  }

  get radioLabelPersonalReportDisplayTypeSelfGrowthSupport(): GEnum.PersonalReportDisplayType {
    return GEnum.PersonalReportDisplayType.SelfGrowthSupport;
  }

  get radioLabelPersonalReportDisplayTypeDiscoverStrengths(): GEnum.PersonalReportDisplayType {
    return GEnum.PersonalReportDisplayType.DiscoverStrengths;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get isEventCreate(): boolean {
    return jgrowEventCreateModule.jgrowEventPageModeCreate;
  }

  get isEventEdit(): boolean {
    return jgrowEventCreateModule.jgrowEventPageModeEdit;
  }

  get isTitleInvalid(): boolean {
    return this.$v.eventParam.title.$dirty && this.$v.eventParam.title.$invalid;
  }

  get isValid(): boolean {
    const {
      gJgrowEventCreateEventTermDate,
      gJgrowEventCreateTermSurveyAtBefore,
      gJgrowEventCreateTermSurveyAtAfter,
      gJgrowEventCreateTermExamAtBefore,
      gJgrowEventCreateTermExamAtAfter,
    }: any = this.$refs;
    this.$v.eventParam.title.$touch();
    gJgrowEventCreateEventTermDate.touch();
    gJgrowEventCreateTermSurveyAtBefore.touch();
    gJgrowEventCreateTermSurveyAtAfter.touch();
    // 新規作成時
    if (this.isEventCreate) {
      gJgrowEventCreateTermExamAtBefore.touch();
      gJgrowEventCreateTermExamAtAfter.touch();
      return (
        !this.isTitleInvalid &&
        gJgrowEventCreateEventTermDate.isValid() &&
        gJgrowEventCreateTermSurveyAtBefore.isValid() &&
        gJgrowEventCreateTermSurveyAtAfter.isValid() &&
        gJgrowEventCreateTermExamAtBefore.isValid() &&
        gJgrowEventCreateTermExamAtAfter.isValid()
      );
    } else {
      // 新規作成時以外は、受検関連の日付をチェックしない
      return (
        !this.isTitleInvalid &&
        gJgrowEventCreateEventTermDate.isValid() &&
        gJgrowEventCreateTermSurveyAtBefore.isValid() &&
        gJgrowEventCreateTermSurveyAtAfter.isValid()
      );
    }
  }
}
